import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip } from '@mui/material';

// Components
import { ModelList } from '../../../components/PaginatedList/ModelList';

// Styles
import { HorizontalStack, SmartContainer } from '../../../styles/Containers'
import { DefaultContentCard } from '../../components/Content/DefaultContentCard';
import { EmptyList } from '../../components/Empty/EmptyList';

// Redux
import { createGenericTag, restoreGenericTag, searchGenericTags } from './redux/generictags.actions';
import { FullGenericTags } from './redux/generictags.selectors';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { IconFeed, IconGrid } from '../../Icons';
import { DefaultContentCardList } from '../../components/Content/DefaultContentCardList';


export const GenericTagsList = ({ onSelect, filters = null, prepend = false }) => {

    // New Modal
    const dispatch = useDispatch();
    const [view, setView] = useState('all');
    const store = FullGenericTags();
    const [grid, setGrid] = useState(true);

    // --------------------------
    // Interactions
    // --------------------------

    // On Select
    const handleSelect = (item) => onSelect(item);
    const renderEmpty = () => {

        return (
            <SmartContainer>
                <EmptyList model="tag" buttonText="create a new tag" label="new tag" selector={FullGenericTags} createAction={createGenericTag} />
            </SmartContainer>
        )
    }

    const renderCustomControls = () => {

        return (
            <HorizontalStack width="100%" flex align="center" justify="space-between">
                <p></p>
                <SmartContainer>
                    <Tooltip title="List or Grid View" placement="top">
                        <StyledIconButton onClick={() => setGrid(!grid)}>
                            {!grid && (<IconGrid />)}
                            {grid && (<IconFeed />)}
                        </StyledIconButton>
                    </Tooltip>
                </SmartContainer>
            </HorizontalStack>
        )
    }

    const renderMediaCard = (item, onClickItem) => {
        if (!grid) return (<DefaultContentCardList content={item} onClick={onClickItem} filters={filters} model="GenericTag" />)
        return (<DefaultContentCard content={item} onClick={onClickItem} filters={filters} model="GenericTag" />)
    }

    const variant = (grid) ? 'cards' : 'list';

    // Render Page
    return (
        <ModelList
            model="GenericTag"
            action={searchGenericTags}
            restore={restoreGenericTag}
            selector={FullGenericTags}
            onSelect={handleSelect}
            variant={variant}
            defaultLimit={999}
            emptyRenderer={renderEmpty}
            customRenderer={renderMediaCard}
            prepend={prepend}
            mobileColumns={2}
            paginationControls={renderCustomControls}
        />
    )
}